import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageAdd"><Path d="M4 2V22H15V20H12V14H15V11H20V2H4Z" fill="currentColor"/><Path d="M19 16V13H17V16H14V18H17V21H19V18H22V16H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageAdd;
